import { format, formatDistanceToNowStrict } from "date-fns";

export function money(amount: number, currency = "gbp") {
  return new Intl.NumberFormat("en-GB", {
    style: "currency",
    currency: currency.toUpperCase(),
    maximumFractionDigits: amount % 1 === 0 ? 0 : 2,
  }).format(amount);
}

/** API dates are UTC ISO strings; they are shown in the viewer's local time. */
export function dateTime(value?: string | null) {
  return value ? format(new Date(value), "d MMM yyyy, HH:mm") : "—";
}

export function date(value?: string | null) {
  return value ? format(new Date(value), "d MMM yyyy") : "—";
}

export function timeRange(start?: string | null, end?: string | null) {
  if (!start) return "Not scheduled yet";
  const s = new Date(start);
  const e = end ? new Date(end) : null;
  return `${format(s, "EEE d MMM yyyy, HH:mm")}${e ? `–${format(e, "HH:mm")}` : ""}`;
}

export function relative(value: string) {
  return formatDistanceToNowStrict(new Date(value), { addSuffix: true });
}

export function fileSize(bytes?: number | null) {
  if (!bytes) return "";
  if (bytes < 1024) return `${bytes} B`;
  if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(0)} KB`;
  return `${(bytes / 1024 / 1024).toFixed(1)} MB`;
}

/** Mentorship time: 90 → "1 h 30 min", 60 → "1 h", 30 → "30 min". */
export function minutesLabel(minutes?: number | null) {
  const value = minutes ?? 0;
  const sign = value < 0 ? "-" : "";
  const abs = Math.abs(value);
  const h = Math.floor(abs / 60);
  const m = abs % 60;
  if (h === 0) return `${sign}${m} min`;
  return m === 0 ? `${sign}${h} h` : `${sign}${h} h ${m} min`;
}

export function duration(seconds?: number | null) {
  if (!seconds) return "";
  const m = Math.floor(seconds / 60);
  const s = Math.round(seconds % 60);
  return `${m}:${s.toString().padStart(2, "0")}`;
}
